"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lte = lte;
function lte(num1, num2, options) {
  return num1 <= num2 ? options.fn(this) : options.inverse(this);
}